import {createReduxStore, register, select, useDispatch, useSelect} from '@wordpress/data';

export const TOAST_STORE_KEY = 'epi/toast';

const DEFAULT_STATE = {
    list: [],
    nextId: 1,
};

const AT = {
    ADD: 'ADD',
    REMOVE: 'REMOVE',
    CLEAR: 'CLEAR',
};

const actions = {
    add(payload) {
        return {type: AT.ADD, payload};
    },
    remove(id) {
        return {type: AT.REMOVE, id};
    },
    clear() {
        return {type: AT.CLEAR};
    },
};

function reducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case AT.ADD: {
            const providedId = action.payload?.id;
            const id = typeof providedId === 'number' ? providedId : state.nextId;
            const toast = {id, ...action.payload};
            return {
                ...state,
                nextId: id >= state.nextId ? id + 1 : state.nextId,
                list: [...state.list, toast],
            };
        }
        case AT.REMOVE:
            return {...state, list: state.list.filter((t) => t.id !== action.id)};
        case AT.CLEAR:
            return {...state, list: []};
        default:
            return state;
    }
}

const selectors = {
    getToasts(state) {
        return state.list;
    },
};

if (!select(TOAST_STORE_KEY)) {
    register(createReduxStore(TOAST_STORE_KEY, { reducer, actions, selectors }));
}

export const useToastDispatch = () => useDispatch(TOAST_STORE_KEY);
export const useToasts = () => useSelect((select) => select(TOAST_STORE_KEY).getToasts(), []);
